import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericRadioButton } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';


const CurrencyTypeInput: InputWithSource = ({ input }) => <GenericRadioButton label={input.name} input={input} />;

CurrencyTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(CurrencyTypeInput);
